<div class="wrapper">
  <div class="cuerpo">

    <h1 class="tp-navandu line-navandu">GENERACIÓN DE DOCUMENTO</h1>

    @if (loading) {
    <app-spinner></app-spinner>
    } @else {
    <form name="entrar" [formGroup]="documentForm" class="formulario" autocomplete="off">
      <div class="  documento">
        @if (signerAdressee!=null) {
        <div class="info-destinatario">
          <div class="switch-button">
            <label class="varios-firmantes">¿Doble factor de autentificación?</label>
            <input type="checkbox" name="switch-button2" id="switch-label2" class="switch-button__checkbox"
              (click)="checkOpenid($event)">
            <label for="switch-label2" class="switch-button__label"></label>
            <label class="varios-firmantes">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;¿Enviar correo
              con documento firmado?</label>
            <input type="checkbox" name="switch-button" id="switch-label" class="switch-button__checkbox"
              (click)="checkSendEmail($event)">
            <label for="switch-label" class="switch-button__label"></label>
          </div>
          <h2 class="tp-navandu"> INFORMACIÓN DEL DESTINATARIO </h2>
          <div class="flex-row info-dest">
            <mat-form-field class="email">
              <mat-label>Nombre</mat-label>
              <input matInput disabled>{{signerAdressee.name}} {{signerAdressee.lastName}}
            </mat-form-field>
            <mat-form-field class="email">
              <mat-label>Móvil</mat-label>
              <input matInput disabled>{{signerAdressee.phone}}
            </mat-form-field>
            <mat-form-field class="email">
              <mat-label>Email</mat-label>
              <input matInput disabled>{{signerAdressee.email}}
            </mat-form-field>
          </div>
        </div>
        }
      </div>
      @if (showSignatureChanels || documentForm.controls['signatureType'].value == 2 || template.templateType.name ===
      'File' || doneImageConvert==='loading') {
      <div class="documento">
        @if (showSignatureChanels) {
        <div class="flex-row">
          <mat-form-field>
            <mat-label>Tipo de firma</mat-label>
            <mat-select required formControlName="signatureType">
              @for (chanel of signatureChanels; track chanel) {
              <mat-option [value]="chanel.id">
                {{chanel.name}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (documentForm.controls.signatureType.value == 3 || !showEmailSigned) {
          <mat-form-field>
            <mat-label>Email</mat-label>
            <mat-select required formControlName="emailRemote">
              @for (optionEmailRemote of emailOptions; track optionEmailRemote) {
              <mat-option [value]="optionEmailRemote">
                {{optionEmailRemote}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          }
        </div>
        }
        @if (documentForm.controls['signatureType'].value == 2) {
        <div class="flex-row">
          <mat-form-field>
            <mat-label>Dispositivo</mat-label>
            <mat-select formControlName="device">
              @for (device of devices; track device) {
              <mat-option [value]="device.deviceName">
                {{device.deviceDescription}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        @if (template.templateType.name === 'File') {
        <mat-form-field>
          <div>
            <mat-toolbar>
              <input matInput [(ngModel)]="fileAttr" readonly name="name" [ngModelOptions]="{standalone: true}" />
              <input type="button" mat-flat-button color="primary" class="boton-up" value="Subir archivo">
            </mat-toolbar>
            <input type="file" #fileInput id="uploadFile" (change)="converter($event)" name="uploadFile"
              accept="application/pdf" />
            @if (reader.readyState == 1) {
            <div>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
            }
          </div>
        </mat-form-field>
        }
        @if (doneImageConvert==='loading') {
        <app-spinner></app-spinner>
        }
        @if (doneImageConvert === 'done') {
        <div>
          <div class="select-state">
            <button mat-icon-button class="refrescar" (click)="changePage('previus')">
              <div class="tooltip3">
                <mat-icon>chevron_left</mat-icon>
                <span class="tooltiptext3">Anterior</span>
              </div>
            </button>
            <p>Página: {{pageImagePdf +1}} de {{lengthPageImagePdf}}</p>
            <button mat-icon-button class="refrescar" (click)="changePage('next')">
              <div class="tooltip3">
                <mat-icon>chevron_right</mat-icon>
                <span class="tooltiptext3">Siguiente</span>
              </div>
            </button>
          </div>
          <div class="example-boundary" [style.backgroundImage]="'url('+ imagepdf +')'">
            <div class="example-box" cdkDragBoundary=".example-boundary" cdkDrag (cdkDragEnded)="dragEnd($event)">
              Ubicación de firma
            </div>
          </div>
        </div>
        }
      </div>
      }
      @if (template.templateType.name === 'SetAdmin' || template.templateType.name === 'SetSigner' ||
      template.templateType.name === 'SetUp') {
      <div class="documento">
        @if (template.content != undefined) {
        <div class="borrador">
          <h1>{{template.name}}</h1>
          <div [innerHTML]="template.content | safeHtml"></div>
        </div>
        }
      </div>
      }
      <div class="enviar">
        <input type="submit" class="boton" value="Enviar" (click)="onSubmit()" [disabled]="buttonDisable">
      </div>
      <a routerLink="/processes/{{idProcess}}" class="volver"><span>Volver</span> </a>
    </form>
    }
  </div>
</div>